import { render } from "./Penerimaan.vue?vue&type=template&id=1075dc94"
import script from "./Penerimaan.vue?vue&type=script&lang=js"
export * from "./Penerimaan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__